import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import TableBase from "./TableBase.vue";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { CheckApprovalVacation } from "@/models/approval/ApprovalResponse";
import VacationExpandItem from "../expand/VacationExpandItem.vue";

type Props = {
  shiftId: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'VacationDialogTable',
  props: {
    shiftId: null
  },
  setup(__props: any) {

const props = __props as {
  shiftId: string;
};



const items = ref<CheckApprovalVacation[]>([]);

const getItems = async () => {
  const response = await $get<CheckApprovalVacation[]>(
    `${Paths.approval.shiftTable.vacation}/${props.shiftId}`
  );
  if (response) items.value = response;
};

watch(
  () => props.shiftId,
  async () => {
    await getItems();
  },
  { immediate: true }
);

return { __sfc: true,props, items, getItems, TableBase, VacationExpandItem }
}

})